import isBoolean from 'lodash/isBoolean'
import isEmpty from 'lodash/isEmpty'

export const key = 'animate'

export const process = (chart, config) => {
  if (isBoolean(config)) {
    return chart.animate(config)
  }

  if (!isEmpty(config)) {
    return chart.animate(config)
  }

  return chart
}
